import { Box, Typography, Switch } from '@mui/material';
import PropTypes from 'prop-types';

export const ToggleComponent = ({
  setState = (_value) => {},
  currentState = false,
  disabled = false,
  toggleText = 'Spend toggle',
  hideToggle = true,
  subBranchDashboard = false,
}) => {
  if (!hideToggle && !subBranchDashboard) {
    setState(false);
  }
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      width="auto"
      padding="15px 0px 0px 0px"
    >
      <Typography
        variant="body1"
        style={{ color: 'rgba(0, 0, 0, 0.6)', lineHeight: '1.9em', fontSize: '0.8rem' }}
      >
        {toggleText}
      </Typography>
      <Switch
        checked={currentState}
        disabled={disabled}
        onChange={() => {
          setState(!currentState);
        }}
        color="primary"
        inputProps={{ 'aria-label': 'toggle comparison' }}
      />
    </Box>
  );
};

ToggleComponent.propTypes = {
  setState: PropTypes.func,
  currentState: PropTypes.bool,
  disabled: PropTypes.bool,
  toggleText: PropTypes.string,
  hideToggle: PropTypes.bool,
  subBranchDashboard: PropTypes.bool,
};
